import { useCallback } from 'react'
import LocalCache from '../../backend/LocalCache'
import EventsEngine from '../../engines/EventsEngine'

export type QueryOptions = {
    queryKey: string
}

const useInvalidate = (options: QueryOptions) => {
    const invalidate = useCallback(async () => {
        if (options.queryKey.includes('*')) {
            const keySuffix = options.queryKey.split('/*')[0]
            const allToStale = LocalCache.getLike(keySuffix)
            for (let i = 0; i < allToStale.length; i++) {
                const toStale = allToStale[i]
                LocalCache.setStale(toStale.key)
                EventsEngine.publish('query-cache-stale', { queryKey: toStale.key })
            }
        } else {
            LocalCache.setStale(options.queryKey)
            EventsEngine.publish('query-cache-stale', { queryKey: options.queryKey })
        }
    }, [options.queryKey])

    return invalidate
}

export default useInvalidate
